<template lang="pug">
  v-container.pa-0(fluid)
    v-flex(xs12)
      full-calendar(
        :events="events"
        @event-selected="eventSelected"
        @event-render="eventRender"
      )
</template>

<script>
import 'fullcalendar/dist/fullcalendar.css'
import { createNamespacedHelpers } from 'vuex';
import { FullCalendar } from 'vue-full-calendar'

import { formatToTimeZone } from 'date-fns-timezone';

const { mapState: mapUserInformationState } = createNamespacedHelpers('userInformation');


export default {
  data() {
    return {}
  },
  components: {
    FullCalendar,
  },
  props: {
    tasks: {
      type: Array,
      default: () => [],
    },
    eventClicked: {
      type: Function,
    }
  },
  computed: {
    ...mapUserInformationState(['user']),
    events() {
      return this.tasks.map(task => {
        const start = formatToTimeZone(task.due_at, 'YYYY-MM-DD HH:mm', { timeZone: this.user.timezone })
        const end = formatToTimeZone(task.end_at, 'YYYY-MM-DD HH:mm', { timeZone: this.user.timezone })

        const event = {
          eventObj: task,
          title: task.description,
          start,
          end,
          durationEditable: false,
          resourceEditable: false,
          editable: false,
        }
        if (task.is_campaign_task) {
          event.icon = "flight_takeoff";
        } else if (task.is_nylas_task) {
          event.icon = "compare_arrows";
        } else if (task.isRecurrent) {
          event.icon = "date_range";
        }
        return event
      })
    }
  },
  methods: {
    async eventSelected(value) {
      this.$emit('eventClicked', value.eventObj);
    },
    async eventRender(value, element) {
      if (value.icon) {
        element.find(".fc-title").prepend("<i class='v-icon mr-1 material-icons theme--light'>" + value.icon + "</i>");
      }
    }
  },
};
</script>
